import { Link } from "react-router-dom";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaChevronRight,
} from "react-icons/fa";
// import logo from "../assets/logo-new.png";
import logo from "../assets/TripReserver-Logo.png";

export default function Footer() {
  // Function to fire the conversion tracking event on click
  // const handleCallConversion = () => {
  //   if (typeof window !== "undefined" && typeof window.gtag === "function") {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-18343552397/rJAbCNm_2NYcEI3L8apE",
  //     });
  //   }
  // };

  const handleCallClick = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "phone_click", {
        event_category: "engagement",
        event_label: "TripReserver phone number",
      });
    }
  };

  const exploreLinks = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Contact", to: "/contact" },
    { label: "24/7 Support", to: "/support24x7" },
    { label: "FAQs", to: "/faq" },
  ];

  const flightServiceLinks = [
    { label: "Flight Booking", to: "/booking" },
    { label: "Special Assistance", to: "/special-assistance" },
    { label: "Flight Deals", to: "/flight-deals" },
    { label: "Group Travel", to: "/group-travel" },
  ];

  const railServiceLinks = [
    { label: "Train Booking", to: "/train-booking" },
    { label: "Train Deals", to: "/train-deals" },
    { label: "Train Schedules", to: "/train-schedules" },
    { label: "24/7 Train Support", to: "/24-7-train-support" },
    { label: "Family Train Travel", to: "/family-train-travel" },
    { label: "Business Train Travel", to: "/business-train-travel" },
  ];

  const carServiceLinks = [
    { label: "Car Rental Booking", to: "/car/car-rental-booking" },
    { label: "Airport Car Rental", to: "/car/airport-car-rental" },
    { label: "Luxury Car Rental", to: "/car/luxury-car-rental" },
    { label: "SUV Car Rental", to: "/car/suv-car-rental" },
    { label: "Long-Term Rental", to: "/car/long-term-car-rental" },
    // { label: "24/7 Support", to: "/car/24*7-support" },
  ];

  const legalLinks = [
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms & Conditions", to: "/terms-and-conditions" },
  ];

  return (
    <footer className="relative overflow-hidden bg-[#0f172a] font-sans text-slate-300">
      {/* Subtle Background Accent */}
      <div className="absolute left-0 top-0 h-1 w-full bg-[#2871d3]"></div>

      <div className="mx-auto max-w-7xl px-4 pb-8 pt-16 sm:px-6 lg:px-8 lg:pt-20">
        {/* TOP SECTION: Newsletter CTA */}
        <div className="mb-16 flex flex-col items-center justify-between gap-8 rounded-[2rem] border border-white/10 bg-white/[0.06] p-8 backdrop-blur-sm sm:p-10 lg:flex-row lg:p-12">
          <div className="max-w-2xl text-center lg:text-left">
            <h2 className="mb-3 text-3xl font-extrabold text-white sm:text-4xl">
              Get the best travel deals in your inbox.
            </h2>
            <p className="text-base text-slate-400 sm:text-lg">
              Subscribe to our newsletter for exclusive airline offers, car
              rental discounts, and early access to holiday sales.
            </p>
          </div>

          <div className="flex w-full flex-shrink-0 flex-col items-stretch gap-3 sm:flex-row sm:gap-0 lg:w-auto">
            <div className="relative flex-grow sm:flex-grow-0">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
                <FaEnvelope className="text-slate-400" />
              </div>
              <input
                type="email"
                placeholder="Enter your email address"
                className="block w-full rounded-xl border border-white/20 bg-white/10 p-4 pl-11 text-sm text-white outline-none transition-all placeholder-slate-400 focus:border-transparent focus:ring-2 focus:ring-[#2871d3] sm:w-72 sm:rounded-l-xl sm:rounded-r-none lg:w-80"
              />
            </div>
            <button className="whitespace-nowrap rounded-xl bg-[#2871d3] px-8 py-4 font-bold text-white shadow-lg shadow-blue-900/20 transition-colors hover:bg-[#155bc2] sm:rounded-l-none sm:rounded-r-xl">
              Subscribe
            </button>
          </div>
        </div>

        {/* MIDDLE SECTION: Footer Link Grid */}
        <div className="mb-16 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 xl:gap-8">
          {/* Col 1: Brand Info */}
          <div className="flex flex-col items-start xl:col-span-1">
            <Link
              to="/"
              className="mb-6 inline-flex items-center justify-center overflow-hidden rounded-2xl bg-white p-2 shadow-lg transition-transform duration-300 hover:scale-105 sm:p-3"
            >
              <img
                src={logo}
                alt="TripReserver"
                className="h-12 w-auto object-contain sm:h-14 lg:h-16"
              />
            </Link>
            <p className="mb-6 pr-4 text-sm leading-relaxed text-slate-400">
              TripReserver provides independent booking assistance for travelers
              looking to arrange flights, rent cars, compare fares, and get 24/7
              support during their journey.
            </p>
          </div>

          {/* Col 2: Explore Links */}
          <div>
            <h3 className="mb-6 text-lg font-bold tracking-wide text-white">
              Explore
            </h3>
            <ul className="space-y-4">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="group flex items-center text-sm text-slate-400 transition-colors hover:text-[#70a7ff]"
                  >
                    <FaChevronRight className="-ml-5 mr-2 h-3 w-3 opacity-0 transition-all duration-300 group-hover:ml-0 group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Flight Services */}
          <div>
            <h3 className="mb-6 text-lg font-bold tracking-wide text-white">
              Flight Services
            </h3>
            <ul className="space-y-4">
              {flightServiceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="group flex items-center text-sm text-slate-400 transition-colors hover:text-[#70a7ff]"
                  >
                    <FaChevronRight className="-ml-5 mr-2 h-3 w-3 opacity-0 transition-all duration-300 group-hover:ml-0 group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Rail Services */}
          <div>
            <h3 className="mb-6 text-lg font-bold tracking-wide text-white">
              Rail Services
            </h3>
            <ul className="space-y-4">
              {railServiceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="group flex items-center text-sm text-slate-400 transition-colors hover:text-[#70a7ff]"
                  >
                    <FaChevronRight className="-ml-5 mr-2 h-3 w-3 opacity-0 transition-all duration-300 group-hover:ml-0 group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 5: Car Rental Services */}
          <div>
            <h3 className="mb-6 text-lg font-bold tracking-wide text-white">
              Car Rentals
            </h3>
            <ul className="space-y-4">
              {carServiceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="group flex items-center text-sm text-slate-400 transition-colors hover:text-[#70a7ff]"
                  >
                    <FaChevronRight className="-ml-5 mr-2 h-3 w-3 opacity-0 transition-all duration-300 group-hover:ml-0 group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 6: Contact Info */}
          <div>
            <h3 className="mb-6 text-lg font-bold tracking-wide text-white">
              Contact Us
            </h3>
            <ul className="space-y-5">
              <li>
                <a
                  href="tel:+18889771997"
                  onClick={handleCallClick}
                  className="group flex items-start gap-3"
                >
                  <div className="rounded-lg bg-white/10 p-2.5 transition-colors group-hover:bg-[#2871d3]">
                    <FaPhoneAlt className="text-sm text-white" />
                  </div>
                  <div>
                    <p className="mb-0.5 text-xs tracking-wider text-slate-500 uppercase">
                      Call Us 24/7
                    </p>
                    <p className="text-sm font-semibold text-white">
                      1-888-977-1997
                    </p>
                  </div>
                </a>
              </li>
              <li>
                <a
                  href="mailto:reservations@TripReserver.com"
                  className="group flex items-start gap-3"
                >
                  <div className="rounded-lg bg-white/10 p-2.5 transition-colors group-hover:bg-[#2871d3]">
                    <FaEnvelope className="text-sm text-white" />
                  </div>
                  <div>
                    <p className="mb-0.5 text-xs tracking-wider text-slate-500 uppercase">
                      Email Us
                    </p>
                    <p className="break-all text-sm font-semibold text-white">
                      reservations@TripReserver.com
                    </p>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="rounded-lg bg-white/10 p-2.5">
                  <FaMapMarkerAlt className="text-sm text-white" />
                </div>
                <div>
                  <p className="mb-0.5 text-xs tracking-wider text-slate-500 uppercase">
                    Location
                  </p>
                  <p className="text-sm font-semibold text-white">
                    30 N Gould St, STE R, Sheridan, WY 82801, USA
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* BOTTOM SECTION: Disclaimer & Copyright */}
        <div className="flex flex-col gap-6 border-t border-white/10 pt-8">
          <div className="flex flex-col items-center gap-4 rounded-xl border border-white/5 bg-white/5 p-6 text-center md:flex-row md:text-left">
            <div className="flex-shrink-0 rounded-lg bg-[#2871d3] p-2">
              <svg
                className="h-5 w-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <p className="max-w-5xl text-xs leading-relaxed text-slate-400 sm:text-sm">
              <strong className="text-white">
                Independent Service Disclaimer:
              </strong>{" "}
              TripReserver is an online platform that helps users compare travel
              information and connect with booking support. We are not a
              licensed airline or car rental provider, nor do we provide our own
              flights or vehicles. While we aim to provide useful availability
              and deals, rates can change at any time and the cheapest rate
              cannot be guaranteed. We act solely as an independent
              intermediary.
            </p>
          </div>

          <div className="flex flex-col items-center justify-between gap-4 text-sm text-slate-500 md:flex-row">
            <p>
              &copy; {new Date().getFullYear()} TripReserver. All rights
              reserved.
            </p>
            <ul className="flex flex-wrap justify-center gap-4 sm:gap-6">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="transition-colors hover:text-white"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
